import React,{ useRef, useEffect } from "react";
import Fullscreen from "@arcgis/core/widgets/Fullscreen.js";

const FullScreenMapWidget = ({view}) => {
    
    const fullScreenMapWidgetDiv = useRef(null);
    
    useEffect(()=> {
        if(fullScreenMapWidgetDiv.current){
            const fullScreenMapWidget = new Fullscreen({
                container: fullScreenMapWidgetDiv.current,
                view: view
            }) 
            view.ui.add(fullScreenMapWidget,"bottom-right")
            
            return ()=> {
                fullScreenMapWidget.destroy()
            }
        }
    },[])
    
    return(
    <div ref={fullScreenMapWidgetDiv}></div>
    )   
}

export default FullScreenMapWidget
